import {
  GOOD_CREATE, GOOD_CREATE_FAILURE, GOOD_CREATE_SUCCESS,
  GOOD_DELETE, GOOD_DELETE_FAILURE, GOOD_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    newGoodId: '',
    newGoodsCount: 0
  },
  getters: {
    newGoodId: state => {
      return state.newGoodId
    },
    newGoodsCount: state => {
      return state.newGoodsCount
    }
  },
  actions: {
    [GOOD_CREATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/asovi/goods', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GOOD_CREATE_FAILURE, res.data)
          } else {
            commit(GOOD_CREATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GOOD_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('GOOD_DELETE:' + params.id)
      var data = params.data
      var url = '/asovi/goods/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GOOD_DELETE_FAILURE, res.data)
          } else {
            commit(GOOD_DELETE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [GOOD_CREATE_FAILURE] (state, data) {
      console.log('GOOD_CREATE_FAILURE')
    },
    [GOOD_CREATE_SUCCESS] (state, data) {
      console.log('GOOD_CREATE_SUCCESS')
      state.newGoodId = data.data.good_id
      state.newGoodsCount = data.data.goods_count
      if (data.callback) {
        data.callback()
      }
    },
    [GOOD_DELETE_FAILURE] (state, data) {
      console.log('GOOD_DELETE_FAILURE')
    },
    [GOOD_DELETE_SUCCESS] (state, data) {
      console.log('GOOD_DELETE_SUCCESS')
      state.newGoodId = ''
      state.newGoodsCount = data.data.goods_count
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/good.js